import { cn } from '@spiaggeit/spit-ui'
import { forwardRef } from 'react'
import { Icon } from '@/assets/icons'

export interface CheckboxIndicatorProps {
  checked: boolean
  hasError?: boolean
  labelledBy?: string
}

export const CheckboxIndicator = forwardRef<
  HTMLSpanElement,
  CheckboxIndicatorProps
>(function CheckboxIndicator({ checked, hasError, labelledBy }, ref) {
  return (
    <>
      <span
        aria-checked={!!checked}
        aria-invalid={hasError && !checked}
        aria-labelledby={labelledBy}
        className={cn(
          'checkbox-indicator peer inline-flex h-5 w-5 shrink-0 items-center justify-center border transition-colors aria-checked:border-blue-500 aria-checked:bg-blue-500',
          hasError && !checked ? 'border-red-600' : 'border-gray-400'
        )}
        ref={ref}
        role="checkbox"
        tabIndex={0}
      />

      <Icon
        className="absolute translate-y-2 text-white opacity-0 transition-all peer-aria-checked:translate-y-0 peer-aria-checked:opacity-100"
        name="ApproveTick"
      />
    </>
  )
})
